module.exports = __webpack_public_path__ + "static/img/after.ae78738.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/after.png
// module id = UsTH
// module chunks = 1